import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResetPassword } from './reset';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { alert } from 'devextreme/ui/dialog';
import { filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth-service.service';


@Component({
  selector: 'ngx-auth-reset',
  templateUrl: './auth-reset.component.html',
  styleUrls: ['./auth-reset.component.scss']
})
export class AuthResetComponent implements OnInit {
  token: string;
  user: ResetPassword = new ResetPassword();
  errors: string[] = [];
  submitted: boolean = false;
  culture: string;

  constructor(private _route: ActivatedRoute, private _http: HttpClient, private _router: Router,
    private _translateService: TranslateService, private _authService: AuthService
  ) { }

  ngOnInit() {
    this._route.queryParams
      .pipe(filter(params => params.token))
      .subscribe(params => {
        this.token = params.token;
      });
    this.culture = this._authService.getCulterByLanguage();
  }

  reset() {
    this.errors = [];
    this.submitted = true;
    if (this.user.password != this.user.confirmpassword) {
      this.errors.push(this._translateService.instant('WACHTWOORD_INSTELLEN.MELDING_WACHTWOORDEN_KOMEN_NIET_OVEREEN'));
    } else {
      this.user.token = this.token;
      this._http.post(environment.API_URL + 'user/resetpassword?culture=' + this.culture, this.user).subscribe(data => {
        this.submitted = false;
        alert(this._translateService.instant('WACHTWOORD_INSTELLEN.MELDING_WACHTWOORD_AANGEPAST'), this._translateService.instant('ALGEMEEN.GELUKT')).then(data => {
          this._router.navigate(['auth', 'login']);
        });

      }, error => {
        this.submitted = false;
        if (error.error == null) {
          this.errors[0] = this._translateService.instant('WACHTWOORD_INSTELLEN.TECHNISCH_PROBLEEM');
        } else if (Array.isArray(error.error)) {
          this.errors = error.error;
        } else {
          this.errors[0] = error?.error;
        }
        this.submitted = false;
      })
    }
  }

}
